import { render, staticRenderFns } from "./SermonsPage.vue?vue&type=template&id=bfc4cb40&"
import script from "./SermonsPage.vue?vue&type=script&lang=js&"
export * from "./SermonsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports